export const servicesPages = {
  list: () => import('./pages/ServicesPage'),
  detail: () => import('./pages/ServiceDetailPage'),
};
